import { AlternativeWarningIcon } from 'assets/icons'
import Card from './Card'

interface InfoCardProps {
  children: React.ReactNode
  className?: string
}

const InfoCard = ({ children, className = '' }: InfoCardProps) => (
  <Card
    className={`flex gap-2 items-center font-bold leading-tight text-2xs text-black !outline-none bg-white p-3 ${className}`}
  >
    <AlternativeWarningIcon className='w-6 h-6 shrink-0' />
    <div>{children}</div>
  </Card>
)

export default InfoCard
